<template>

  <div id="story" class="section">
      <div class="story_top"></div>
    <div class="story_bottom">
      <div class="story_text">
        <h1>Story</h1>
        <p>
        映画監督として活躍する野沢徹と、愛くるしい息子のユウスケ。<br class="norm_br">
        三人で暮らす生活に何ひとつ不満のないミカだが、<br class="norm_br">
        どこかその顔は不安げに曇っている。<br class="norm_br">
        夢を諦めきれない徹と、そんな徹が好きだったミカ。<br class="norm_br">
        だが、そんな二人の前に立ちはだかる現実はときに残酷だった…<br class="norm_br">
        </p>
      </div>
    </div>

  </div>
</template>

<style>

  #story{
  /* border: 2px solid rgb(1, 60, 10);  */

  position: relative;
  width: 100%;
  height: auto;
  align-items:flex-start;
}

.story_top{
  /* border: 2px solid rgb(1, 60, 10);  */
  position: relative;
  background-image: url('../assets/Story.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  justify-content: center;
  align-items: center;
  object-fit:contain;
  width: 100%;
  height: auto;
  padding-bottom: 28%;
  align-items:flex-start;
}

.story_bottom{
  /* border: 3px solid rgb(210, 35, 61);  */
  width: 100%;
  height: auto;
  display: flex;
  padding-bottom: 5vh;
  margin-top: 3vh;
  align-items: center;
  justify-content: center;
}
.story_text{
  /* border: 5px solid rgb(199, 210, 35);  */
  font-family: 'Shippori Mincho', sans-serif;
  width:auto;
  height:auto;
  padding: 0vw;
  margin-left: 20vw;
  margin-right: 20vw;
  padding-top: 0%;
  padding-bottom: 15vh;
  

}

.story_text h1{
  line-height: 0.8;
  letter-spacing: 1px;
  font-size:calc(32px);
  margin-left: 0px;
}

.story_text p{
  /* border: 5px solid rgb(199, 210, 35);  */
  Width:auto;
  font-size:calc(14px);
  line-height: 1.8;
  letter-spacing: 2px;
  font-weight:normal; 
  margin-left: 0px;
  word-wrap: normal;
  overflow-wrap:break-word;
  text-align: justify;
  margin-top: 3vh;


}

.norm_br{
  display: block;
}
@media screen and (max-width:380px){
 .norm_br{
  display: none;
  }
}


</style>